define('app-CarouselJumbotron/main',['./settings'], function (settings) {
    return {

        run: function () {
            if (settings.jumbotronCarousel.length === 0) {
                window.log('No jumbotron carousel container found.  Jumbotron carousel will not be available.');
                return;
            }

            window.log('Loading jumbrotron carousel...');

            $.ajax({
                url: settings.jumbotronCarouselUrl,
                type: "GET",
                success: function (responseData) {

                    if (responseData.length !== 0 && responseData.model.imagesEmpty != true) {

                        $('.newHeroContent').removeAttr('id', 'frostedContentsInner');

                        //Hide widget errors
                        $('h2:contains("Object moved")').hide();
                        $('title:contains("Error")').hide();
                        $('hgroup:contains("Error")').hide();

                        //Add classname for default slide
                        $('.newHeroContent h1,.newHeroContent h2,.newHeroContent .btn-group:eq(0)').wrapAll(settings.defaultSlideDiv);

                        //Mobile
                        settings.mobileSlideH1.html(responseData.model.mobileH1).attr("style", responseData.model.mobileH1Style);
                        settings.mobileSlideH2.html(responseData.model.mobileH2).attr("style", responseData.model.mobileH2Style);

                        //Desktop or tablet screen size, else hide tabs on mobile
                        if ($(window).width() > 768) {

                            //Carousel start
                            //Text boxs - box1 for second slide, box2 for third slide
                            var textBox1 = BuildTextBoxContent('box1 secondSlide', responseData.model.textTwoH1Style, responseData.model.textTwoH1,
                                responseData.model.textTwoH2Style, responseData.model.textTwoH2, responseData.model.textTwoButtonText, responseData.model.textTwoButtonLink
                            );
                            var textBox2 = BuildTextBoxContent('box2 thirdSlide', responseData.model.textThreeH1Style, responseData.model.textThreeH1,
                                responseData.model.textThreeH2Style, responseData.model.textThreeH2, responseData.model.textThreeButtonText, responseData.model.textThreeButtonLink
                            );
                            var textBox3 = BuildTextBoxContent('box3 fourthSlide', responseData.model.textFourH1Style, responseData.model.textFourH1,
                                responseData.model.textFourH2Style, responseData.model.textFourH2, responseData.model.textFourButtonText, responseData.model.textFourButtonLink
                            );

                            function BuildTextBoxContent(boxSlideClass, h1Style, h1Text, h2Style, h2Text, buttonText, buttonLink) {
                                return $('<div/>', {
                                    'class': boxSlideClass,
                                    html: $('<h1/>', {
                                        'style': h1Style,
                                    }).html(h1Text).add($('<h2/>', {
                                        'style': h2Style,
                                    }).html(h2Text)).add($('<div/>', {
                                        'style': 'clear:both;',
                                    })).add($('<div/>', {
                                        'class': 'btn-group',
                                        'style': 'margin-bottom: 0px;',
                                        html: $('<a/>', {
                                            'text': buttonText,
                                            'class': 'btn btn-third',
                                            'href': buttonLink
                                        })
                                    }))
                                });
                            }

                            //Jumbotron controls
                            settings.jumbotronAnimated.prepend(settings.carouselIndicators);

                            //Carousel controls
                            var carouselTimer;

                            function runCarousel() {
                                if (carouselTimer == null || undefined) {
                                    carouselTimer = setInterval(carouselInterval, responseData.model.setImageTimeout);
                                }
                            }

                            function stopCarousel() {
                                clearInterval(carouselTimer);
                                carouselTimer = null;
                            }

                            //Add pause when hovering over jumbotron text box
                            $('.carouselJumbotron').mouseenter(function () {
                                stopCarousel();
                            }).mouseleave(function () {
                                runCarousel();
                            });

                            function imageSlide(slideNumber, imageUrl) {
                                var slideOrder = [0, 0, 0];

                                if (slideNumber == 1) {
                                    slideOrder = [0, 2, 3];
                                }
                                else if (slideNumber == 2) {
                                    slideOrder = [0, 1, 3];
                                }
                                else if (slideNumber == 3) {
                                    slideOrder = [0, 1, 2];
                                }
                                else {
                                    slideOrder = [1, 2, 3];
                                }

                                settings.jumbotronAnimated.switchClass("image" + slideOrder[0], "image" + slideNumber);
                                settings.jumbotronAnimated.switchClass("image" + slideOrder[1], "image" + slideNumber);
                                settings.jumbotronAnimated.switchClass("image" + slideOrder[2], "image" + slideNumber);

                                $('.image' + slideNumber).css('background-image', 'url(' + imageUrl + ')');
                                $('.box' + slideNumber).show();
                                $('.box' + slideOrder[0] + ',.box' + slideOrder[1] + ',.box' + slideOrder[2]).hide();
                                $('.carouselDiscs').removeClass('active');
                                $('.carouselDisc' + slideNumber).addClass('active');
                            }

                            function carouselInterval() {
                                if ($('.image0').length && responseData.model.imageOne != "") {
                                    imageSlide(1, responseData.model.imageTwo)
                                }
                                else if ($('.image1').length && responseData.model.imageTwo != "") {
                                    imageSlide(2, responseData.model.imageThree)
                                }
                                else if ($('.image2').length && responseData.model.imageThree != "") {
                                    imageSlide(3, responseData.model.imageFour)
                                }
                                else if ($('.image3').length && responseData.model.imageFour != "") {
                                    imageSlide(0, responseData.model.imageOne)
                                } else {
                                    settings.jumbotronAnimated.css('background-image', 'url(' + responseData.model.imageOne + ')');
                                    settings.jumbotronAnimated.addClass('image0');
                                }
                            };

                            //Add content here rather than onslide
                            $('.newHeroContent').append(textBox1, textBox2, textBox3);
                            $('.newHeroContent div:eq(0)').addClass('box0');
                            $('.box1,.box2,.box3').hide();
                            $('.carouselDiscs').removeClass('active');
                            $('.carouselDisc0').addClass('active');

                            //Discs to change the slide manually
                            $('.carouselDisc0').on('click', function () {
                                stopCarousel();
                                imageSlide(0, responseData.model.imageOne)
                                setTimeout(function () { runCarousel() }, responseData.model.setImageTimeout);
                            });
                            $('.carouselDisc1').on('click', function () {
                                stopCarousel();
                                imageSlide(1, responseData.model.imageTwo)
                                setTimeout(function () { runCarousel() }, responseData.model.setImageTimeout);
                            });
                            $('.carouselDisc2').on('click', function () {
                                stopCarousel();
                                imageSlide(2, responseData.model.imageThree)
                                setTimeout(function () { runCarousel() }, responseData.model.setImageTimeout);
                            });
                            $('.carouselDisc3').on('click', function () {
                                stopCarousel();
                                imageSlide(3, responseData.model.imageFour)
                                setTimeout(function () { runCarousel() }, responseData.model.setImageTimeout);
                            });

                            runCarousel();

                        }
                        else {
                            //Mobile hide other rows on load
                            contentDataRow2.hide();
                            contentDataRow3.hide();
                            contentDataRow4.hide();
                        };

                    }
                    else {

                        //Add classname for default slide
                        $('.newHeroContent h1,.newHeroContent h2,.newHeroContent .btn-group:eq(0)').wrapAll(settings.defaultSlideDiv);
                        return;
                    }

                },

                error: function () {
                    window.log('No jumbotron carousel data found.  Jumbotron carousel will not be available.');
                }
            });

        }
    }
});
